import { Box } from '@mui/material';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import React from 'react';
import InventoryDTO from '@src/adapters/dto/inventory/InventoryDTO';

interface Props {
  select(inventory: InventoryDTO): void;
  selected?: InventoryDTO;
  inventories: InventoryDTO[];
  setCurrentPage(page: number): void;
  setRowsPerPage(rows: number): void;
  currentPage: number;
  recordCount: number;
  rowsPerPage: number;
}

function InventoryList({
  select,
  selected,
  inventories,
  setCurrentPage,
  setRowsPerPage,
  currentPage,
  recordCount,
  rowsPerPage,
}: Props) {
  const handleRowClick = (
    event: React.MouseEvent<unknown>,
    inventory: InventoryDTO
  ) => {
    select(inventory);
  };

  const isSelected = (inventory: InventoryDTO) => {
    return selected && selected.id === inventory.id;
  };

  return (
    <Box sx={{ width: '100%' }}>
      <TableContainer>
        <Table
          sx={{ minWidth: 750 }}
          aria-labelledby="tableTitle"
          size="small"
          aria-label="Contents table">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Alias Count</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {inventories.map((inventory, index) => {
              const isItemSelected = isSelected(inventory);
              return (
                <TableRow
                  hover
                  onClick={(event) => handleRowClick(event, inventory)}
                  role="checkbox"
                  aria-checked={isItemSelected}
                  tabIndex={-1}
                  key={index}
                  selected={isItemSelected}>
                  <TableCell scope="row">{inventory.name}</TableCell>
                  <TableCell scope="row">{inventory.aliases.length}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={recordCount}
        rowsPerPage={rowsPerPage}
        page={currentPage}
        onPageChange={(event, number) => setCurrentPage(number)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setCurrentPage(0);
        }}
      />
    </Box>
  );
}

export default InventoryList;
